// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_0Rx","cls2":"LoswpExitIntentModal-cls2_ves LoswpExitIntentModal-cls1_0Rx"};